import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";
import NewLoginModel from "@Components/Comment/NewLoginModel"; // 登录弹窗
import CommentInput from "./CommentInput"; // 评论输入框
import { fetchUserProfile, fetchPcComments, fetchPaging } from "@Services/api";
import { fetchCommentList } from "@Services/article";
import { createGlobalStyle } from "styled-components";
import ShortsComments from "./ShortsComments";
import ArticleComments from "./ArticleComments";

import { article } from "@Api";
import CommentHeader from "./CommentHeader";
import { useThrottleFn } from "ahooks";

const { fatchArticleGetComment } = article;

const GlobalStyle = createGlobalStyle`
  .ant-modal-close-x {
		display: flex!important;
		align-items: center;
		justify-content: center;
	}
`;
interface IState {
  commentNum: any;
  commentData: any[];
  hotComment: any[];
  paging: string;
}

interface NewCommentProps {
  id: string;
  sendCommentApi: (params: any) => Promise<any>;
  type?: string;
  pageType: string;
}

const openNotificationWithIcon = (type, msg = "") => {
  message[type](msg);
};

const NewComment: React.FC<NewCommentProps> = (props) => {
  const { sendCommentApi, id, type, pageType } = props;

  const [showLogin, setShowLogin] = useState(false);
  const [paging, setPaging] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [commentData, setCommentData] = useState({
    comment_num: 0,
    data: []
  });
  const [cData, setCData] = useState<any[]>([]);
  const [interiorCommentData, setInteriorCommentData] = useState<any[]>([]);
  const [modalType, setModalType] = useState("");
  const [modalObj, setModalObj] = useState<any>({
    re_id: "",
    val: "",
    item: {}
  });
  const [remarkData, setRemarkData] = useState<IState>({
    commentNum: "---",
    commentData: [],
    hotComment: [],
    paging: "",
  });

  const loadRef = useRef(null);

  const [userAvatar, setUserAvatar] = useState("https://photo.8891.com.tw/2020/09/25/1601023588157267.png");

  // 登录用户信息
  const getUserInfo = async () => {
    try {
      const res = await fetchUserProfile({});
      if (res.status === "12000" && res.data.data.headpic) {
        setUserAvatar(res.data.data.headpic);
      }
    } catch (e) { }
  };

  const handleSend = async (content: string, reply_id = "", re_mid = "") => {
    const trimmed = content?.trim();
    if (!trimmed) {
      return openNotificationWithIcon("info", "評論內容不能為空");
    }

    try {
      await sendCommentApi({
        type: pageType === "shorts" ? "11" : pageType === "movie" ? "3" : type,
        id: String(id),
        reId: reply_id,
        reMid: re_mid,
        content: trimmed,
      });

      openNotificationWithIcon("success", "評論成功");
      pageType === "article" ? getList() : updateCommentList();
      setInputValue("");
    } catch {
      openNotificationWithIcon("error", "發佈失敗，請稍後再試");
    }
  };

  const pcComments = async (cache) => {
    if (window.page_route === "newCar:shorts/{id}") return;

    try {
      const res = await fetchPcComments({ id, page: 1, limit: 15, cache });
      if (res?.status === "200") {
        setCommentData(res);
        setPaging(res.paging);
        setCData([res.data]);
      }
    } catch (e) { }
  };

  const updateCommentList = async () => {
    try {
      const res = await fetchCommentList({
        limit: 100,
        type: window.page_route === "newCar:shorts/{id}" ? "11" : "3",
        id,
      });

      if (res?.status === 12000) {
        setInteriorCommentData(res.data.list || []);
      }
    } catch (e) { }
  };

  const getList = async () => {
    try {
      const res = await fatchArticleGetComment({ id, type });
      res && articleComment(res);
    } catch (error) {
      console.log(error);
    }
  };

  const articleComment = (data: any) => {
    const hotArr: any = [],
      newArr: any = [];

    hotArr.push(data.hotComment);
    newArr.push(data.data);

    setRemarkData({
      commentData: data?.data?.length === 0 ? [] : newArr,
      commentNum: data?.comment_num,
      paging: data.paging,
      hotComment: data?.hotComment?.length === 0 ? [] : hotArr,
    });
  };

  const onEndReached = async () => {
    if (!paging) return;
    try {
      const res = await fetchPaging(paging);

      let n_data: any[] = [];
      n_data.push(res.data);

      setCData([...cData, ...n_data]);
      setCommentData(res);
      setPaging(res.paging);
    } catch (e) { }
  };

  const { run: throttledLoginSend } = useThrottleFn(() => {
    if (pageType === 'article') {
      handleSend(inputValue);
    } else if (pageType === 'shorts' || pageType === 'movie') {
      const { re_id, val, item } = modalObj;
      modalType === "sendBtn"
        ? handleSend(inputValue)
        : handleSend(val, re_id, item?.user?.mid || '');
    }
  }, { wait: 1000 });
  

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    if (pageType === "shorts" || pageType === "movie") {
      pcComments(1);
      updateCommentList();
    }
    if (pageType === "article") {
      getList();
    }
  }, [pageType]);

  return (
    <div className="px-16 pb-30" id='Comment'>
      <GlobalStyle />

      {/* 评论标题、评论数量、评论链接 */}
      <CommentHeader
        pageType={pageType as "shorts" | "movie" | "article"}
        totalCommentCount={(Number(commentData.comment_num) || 0) + (interiorCommentData.length || 0)}
        showCommentLink={remarkData.commentData.length !== 0}
        commentLink={`/article/comments/list?type=${type}&id=${id}`}
        articleCommentTotal={remarkData.commentNum}
      />

      {/* 留言输入区 */}
      <CommentInput
        userAvatar={userAvatar}
        placeholder={remarkData.commentData.length !== 0 ? "看完文章思如泉湧，快來和小夥伴們交流想法吧~" : "快來發佈第一條評論吧"}
        onSend={(content) => {
          setInputValue(content);
          setModalType("sendBtn");
          setShowLogin(true);
        }}
        pageType={pageType}
      />

      {/* 影音 - 评论列表 */}
      {(pageType === "shorts" || pageType === "movie") && (
        <ShortsComments
          interiorCommentData={interiorCommentData}
          commentData={commentData}
          cData={cData}
          paging={paging}
          loadRef={loadRef}
          onEndReached={onEndReached}
          handleReplyComment={(re_id, val, item) => {
            if (!val) {
              openNotificationWithIcon("info", "評論內容不能為空");
              return;
            }
            setShowLogin(true);
            setModalType("replyBtn");
            setModalObj({ re_id, val, item });
          }}
        />
      )}

      {/* 文章 - 评论列表 */}
      {pageType === "article" && (
        <ArticleComments
          remarkData={remarkData}
          type={type}
          id={id}
          refreshList={() => {
            getList();
          }}
        />
      )}

      {/* 登录弹窗 */}
      <NewLoginModel
        title='發佈評論，與更多用戶交流互動！'
        desc='立即登入，用戶回覆後將同步您'
        visible={showLogin}
        onClose={() => {
          openNotificationWithIcon("info", "您已取消登錄，將以遊客身份發佈評論");
        }}
        setVisible={(status) => {
          throttledLoginSend();
          setShowLogin(status);
        }}
      />
    </div>
  );
};

export default NewComment;
